import { Route, RouteComponentProps, Switch } from 'react-router'
import React from 'react'

import { Display } from './Display'
import {
  REPORTS_DRUG_MODEL_ACCESS_URL,
  REPORTS_SUBSCRIPTION_EXPIRY_ACCESS_URL,
  REPORTS_URL
} from '../../../constants/urls/frontend'
import { DrugModelAccessContainer } from './DrugModelAccess/DrugModelAccessContainer'
import { SubscriptionExpiryContainer } from './SubscriptionExpiry/SubscriptionExpiryContainer'

export const ReportsPage: React.FC<RouteComponentProps> = (): JSX.Element => {
  return (
    <div id='reports-wrapper'>
      <>
        <Switch>
          <Route path={REPORTS_SUBSCRIPTION_EXPIRY_ACCESS_URL} component={SubscriptionExpiryContainer} />
          <Route path={REPORTS_DRUG_MODEL_ACCESS_URL} component={DrugModelAccessContainer} />
          <Route path={REPORTS_URL} component={Display} />
        </Switch>
      </>
    </div>
  )
}
